export default __webpack_public_path__ + "static/media/napping@2x.2d204aa5.png";